import * as Yup from 'yup';

export const consumerConfirmationYopValidation = () => {
  return Yup.object().shape({
    password: Yup.string().required('required'),
  });
};
